export default defineNuxtRouteMiddleware((to, from) => {
  const auth = useAuth(); // Zugriff auf den Auth-Composable
  const loggedIn = auth.loggedIn;
  const redirectTo = useState('authRedirect');
  const localePath = useLocalePath();

  // Wenn die Route Authentifizierung erfordert und der Benutzer nicht eingeloggt ist
  if (to.meta.auth && !loggedIn.value) {
    redirectTo.value = to.fullPath; // Speichere den ursprünglichen Pfad

    // Wenn das Ziel eine Checkout-Seite ist, leite zur Registrierungsseite weiter
    if (to.path.includes('/checkout') || to.path.includes('/odeme')) {
      return navigateTo(localePath({ name: 'signup' })); // Leite zur Registrierungsseite weiter
    }

    return navigateTo(localePath({ name: 'login' })); // Leite zur Login-Seite weiter
  }

  // Wenn der Benutzer eingeloggt ist und auf der Login-Seite ist
  if (loggedIn.value && to.path === localePath('/login')) {
    const target = redirectTo.value || localePath('/userpanel');
    redirectTo.value = null; // Zurücksetzen von redirectTo
    return navigateTo(target); // Leite zum ursprünglichen Pfad oder zum Userpanel weiter
  }

  // Optional: Wenn der Benutzer ausgeloggt ist und sich auf einer geschützten Seite befindet
  if (!loggedIn.value && to.meta.auth) {
    redirectTo.value = to.fullPath;
    return navigateTo(localePath('/login'));
  }
});
